export const getExtraAmountTypeText = (type) => {
  if (type === 'plusCash') return 'Cantidad fija de extras ó descuentos'
  else if (type === 'plusPercentage') return 'Porcentaje de extras ó descuentos'
  else if (type === 'minusCash') return 'Cantidad fija de extras ó descuentos'
  else if (type === 'minusPercentage') return 'Porcentaje de extras ó descuentos'
  else return 'Cantidad fija de extras ó descuentos'
}
